import axios from "~axios"
import EventBus from "~event-bus"

const state = {
    all: [],
    courseViewers: [],
    filters: {},
    products: [],
    expertCourses: [],
    expertCoursesLoad: false,
    cabinetUsers: [],
    usersNumber: 0,
    coursesCards: 0,
    countries: [],
    timezones: [],
    currencies: [],
    languages: [],
    menu: null,
    moderatorFilters: [],
    loaders: {
        timezones: false
    }
}

const getters = {
    filters: state => {
        return state.filters
    },
    menu: state => {
        return state.menu
    },
    courseViewers: state => {
        return state.courseViewers
    },
    products: state => {
        return state.products
    },
    breadCrLoad: state => {
        return state.breadCrLoad
    },
    getExpertCourses: state => {
        return state.expertCourses
    },
    cabinetUsers: state => {
        return state.cabinetUsers
    },
    usersNumber: state => {
        return state.usersNumber
    },
    coursesCards: state => {
        return state.coursesCards
    },

    countries: state => {
        return state.countries
    },
    timezones: state => {
        return state.timezones
    },
    currencies: state => {
        return state.currencies
    },
    languages: state => {
        return state.languages
    },
    moderatorFilters: state => {
        return state.moderatorFilters
    }
}

const mutations = {
    SET_MENU(state, payload) {
        state.menu = payload
    },
    SET_FILTERS(state, payload) {
        //
        state.filters = {
            ...payload,
            is_marketing: [
                { name: "expert.yes", lang_key: "expert.yes", id: 1, value: true },
                { name: "expert.no", lang_key: "expert.no", id: 0, value: false }
            ],
            is_active: [
                { name: "expert.yes", lang_key: "expert.yes", id: 1, value: true },
                { name: "expert.no", lang_key: "expert.no", id: 0, value: false }
            ],
            is_blocked: [
                { name: "expert.yes", lang_key: "expert.yes", id: 1, value: true },
                { name: "expert.no", lang_key: "expert.no", id: 0, value: false }
            ]
        }
    },
    SET_COURSE_VIEWERS(state, newValue) {
        state.courseViewers = [...newValue]

        setTimeout(function () {
            state.breadCrLoad = true
        }, 800)
    },
    CLEAR_COURSE_VIEWERS() {
        state.courseViewers = []
    },
    SET_PRODUCTS(state, newValue) {
        state.expertCourses = newValue
        state.expertCoursesLoad = true
        setTimeout(function () {
            state.breadCrLoad = true
        }, 800)
    },
    SET_CABINET_USERS(state, newValue) {
        state.cabinetUsers = newValue
    },
    SET_USERS_NUMBER(state, newValue) {
        state.usersNumber = newValue
    },
    SET_COURSES_CARDS(state, newValue) {
        state.coursesCards = newValue
    },
    SET_COUNTRIES(state, newValue) {
        state.countries = newValue
    },
    SET_TIMEZONES(state, newValue) {
        state.timezones = newValue
    },
    SET_CURRENCIES(state, newValue) {
        state.currencies = newValue
    },
    SET_LANGUAGES(state, newValue) {
        state.languages = newValue
    },
    SET_MODERATOR_FILTERS(state, newValue) {
        state.moderatorFilters = newValue
    },
    SET_LOADER(state, { key, value }) {
        state.loaders[key] = value
    }
}

const actions = {
    fetchViewers({ commit }, response) {
        commit("SET_COURSE_VIEWERS", response.data.data)
        commit("SET_USERS_NUMBER", response.data.meta.total)
    },
    getMenu({ commit }) {
        axios.get(`/cabinet/menu`).then(response => {
            commit("SET_MENU", response.data.data)
        })
    },
    clearUsersArr({ commit }) {
        commit("CLEAR_COURSE_VIEWERS")
    },
    fetchFilters({ commit }) {
        return axios
            .get(`/contacts/filters`)
            .then(response => {
                commit("SET_FILTERS", response.data.data)
            })
            .catch(e => {
                if (e.response.data.message) {
                    EventBus.$emit("showEventError", e.response.data.message)
                }
            })
    },
    fetchCabinetUsers({ commit }, data) {
        return axios
            .get(`/api/v1/web/cabinets/${data.cabinet_id}/getUsers`, {
                params: {
                    email: data.email
                }
            })
            .then(response => {
                commit("SET_CABINET_USERS", response.data.users)
            })
    },
    fetchExpertCourses({ commit }) {
        return axios.get(`/courses`).then(response => {
            commit("SET_PRODUCTS", response.data.data)
        })
    },
    fetchCoursesCards({ commit }) {
        return axios.get("/courses-cards").then(response => {
            commit("SET_COURSES_CARDS", response.data.data)
        })
    },
    fetchCountries({ commit }) {
        // return axios.get(`/countries`)
        return axios
            .get(window.cached_routes["countries"], { params: { lang: window.app_current_locale } })
            .then(response => {
                let countriesByMultiAlphabet = response.data.data.sort((a, b) => a.name.localeCompare(b.name))
                commit("SET_COUNTRIES", countriesByMultiAlphabet)
            })
    },
    fetchTimezones({ state, commit }) {
        if (state.loaders.timezones) return
        commit("SET_LOADER", { key: "timezones", value: true })
        return axios
            .get(`/timezones`)
            .then(response => commit("SET_TIMEZONES", response.data.data))
            .catch(e => console.log("timezones error:", e))
            .finally(() => commit("SET_LOADER", { key: "timezones", value: false }))
    },
    fetchCurrencies({ commit }) {
        return axios.get(`/currencies/main`).then(response => {
            commit("SET_CURRENCIES", response.data.data)
        })
    },
    fetchLanguages({ commit }) {
        return axios.get(`/languages`, { params: { locale: window.app_current_locale } }).then(response => {
            let langs = response.data.data

            langs = langs.filter(item => item.name)

            commit("SET_LANGUAGES", langs)
        })
    },
    fetchModeratorFilters({ commit }) {
        return axios.get(`/warnings/filters`).then(response => {
            commit("SET_MODERATOR_FILTERS", response.data.data)
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
